module.exports = __webpack_public_path__ + "img/1F495.b1a8af8d.svg";